export default [
  {
    path: '/campaign/edit/:uuid',
    name: 'campaign-edit',
    component: () => import('@/views/campaign/edit/campaign.vue'),
  },
  {
    path: '/campaign/:uuid/list',
    name: 'campaign-list',
    component: () => import('@/views/campaign/campaignsList.vue'),
  },
  {
    path: '/campaign/stores',
    name: 'campaign-stores',
    component: () => import('@/views/campaign/RelatoriosCampanhasSegmentadas.vue'),
  },
  {
    path: '/campaign/todas',
    name: 'campaign-todas',
    component: () => import('@/views/campaign/campaign-oficial/CampanhasOficiaisRedirect.vue'),
  },
  {
    path: '/campaign/inteligentes',
    name: 'campaign-ia',
    component: () => import('@/views/campaign/campanhasInteligentes/CampanhasInteligentes.vue'),
  },
  {
    path: '/campaign/inteligentes/recomendacao',
    name: 'campaign-ia-recomendacao',
    component: () => import('@/views/campaign/campanhasInteligentes/RecomendacaoProdutos.vue'),
  },
  {
    path: '/campaign/inteligentes/metricas',
    name: 'campaign-ia-metricas',
    component: () => import('@/views/campaign/campanhasInteligentes/MetricasRecomendacoes.vue'),
  },
  {
    path: '/campaign/inteligentes/aniversario',
    name: 'campaign-ia-aniversario',
    component: () => import('@/views/campaign/campanhasInteligentes/CampanhasAniversario.vue'),
  },
  {
    path: '/campaign/inteligentes/aniversario/metricas',
    name: 'campaign-ia-aniversario-metricas',
    component: () => import('@/views/campaign/campanhasInteligentes/MetricasAniversario.vue'),
  },
  {
    path: '/campaign/oficiais/:uuid/campanha/:campanhaId/metricas',
    name: 'campaign-oficiais-metricas',
    component: () => import('@/views/campaign/campaign-oficial/MetricasCampanhaOficialPage.vue'),
  },
  {
    path: '/campaign/oficiais/:uuid',
    name: 'campaign-oficiais',
    component: () => import('@/views/campaign/campaign-oficial/CampanhasOficiais.vue'),
  },
  {
    path: '/campaign/admin/dashboard',
    name: 'campaign-admin-dashboard',
    component: () => import('@/views/campaign/admin/DashboardAdmin.vue'),
    meta: {
      requiresAuth: true,
      role: 'admin',
    },
  },
]
